// src/HomePage/Game/Werewolf/roleEngine.js
export const ROLE_DEFINITIONS = {
  WEREWOLF: {
    id: 'WEREWOLF',
    name: 'Ma Sói',
    icon: '🐺',
    team: 'Sói',
    desc: 'Thức dậy vào Ban Đêm Lượt 1 để chọn cắn tử vong 1 dân làng.',
    maxUsesPerNight: 1,
    maxUsesPerGame: -1
  },
  SEER: {
    id: 'SEER',
    name: 'Tiên Tri',
    icon: '🔮',
    team: 'Dân',
    desc: 'Thức dậy vào Ban Đêm Lượt 2 để soi bản phe của 1 người chơi.',
    maxUsesPerNight: 1,
    maxUsesPerGame: -1
  },
  BODYGUARD: {
    id: 'BODYGUARD',
    name: 'Bảo Vệ',
    icon: '🛡️',
    team: 'Dân',
    desc: 'Thức dậy vào Ban Đêm Lượt 2 để bảo vệ 1 người. Không được bảo vệ 1 người 2 đêm liên tiếp.',
    maxUsesPerNight: 1,
    maxUsesPerGame: -1,
    allowConsecutive: false
  },
  WITCH: {
    id: 'WITCH',
    name: 'Phù Thủy',
    icon: '🧪',
    team: 'Dân',
    desc: 'Có 1 bình thuốc cứu và 1 bình thuốc độc dùng trong cả ván game.',
    maxUsesPerNight: 2,
    maxUsesPerGame: 2,
    potions: { save: 1, poison: 1 }
  },
  HUNTER: {
    id: 'HUNTER',
    name: 'Thợ Săn',
    icon: '🏹',
    team: 'Dân',
    desc: 'Được nhắm/đổi mục tiêu 2 lần mỗi ngày (1 lần ban đêm, 1 lần ban ngày). Nếu bị Sói cắn, treo cổ hoặc chết cùng người yêu, mục tiêu sẽ chết theo. Nếu bị Phù Thủy độc chết sẽ KHÔNG thể bắn.',
    maxUsesPerNight: 1,
    maxUsesPerGame: -1
  },
  CUPID: {
    id: 'CUPID',
    name: 'Thần Tình Yêu',
    icon: '💘',
    team: 'Dân',
    desc: 'Bắt buộc se duyên 2 người chơi trong Đêm 1. Nếu không thực hiện sẽ bị trừng phạt tử vong!',
    maxUsesPerNight: 1,
    maxUsesPerGame: 1,
    mustUseOnNight: 1
  },
  VILLAGER: {
    id: 'VILLAGER',
    name: 'Dân Làng',
    icon: '👨‍🌾',
    team: 'Dân',
    desc: 'Lập luận ban ngày và dùng lá phiếu để treo cổ Ma Sói.',
    maxUsesPerNight: 0,
    maxUsesPerGame: 0
  }
};